(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { ProfileManager } from '@kailona/core';
import { GlucoseSystemCodes, getGlucoseSystemDisplay } from '../lib/GlucoseSystemCodes';

function mapToFHIRGlucose(diabetesData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = diabetesData.date,
      glucoseValue = diabetesData.glucoseValue,
      _diabetesData$glucose = diabetesData.glucoseSystem,
      glucoseSystem = _diabetesData$glucose === void 0 ? 'blood' : _diabetesData$glucose;

  if (!date || !glucoseValue) {
    return null;
  }

  var glucoseSystemCode = GlucoseSystemCodes[glucoseSystem];
  var glucoseDisplay = getGlucoseSystemDisplay(glucoseSystem);
  var observation = {
    resourceType: 'Observation',
    status: 'final',
    code: {
      coding: [{
        system: glucoseSystemCode.split('|')[0],
        code: glucoseSystemCode.split('|')[1],
        display: glucoseDisplay
      }],
      text: 'Glucose'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    issued: moment().utc().toISOString(),
    valueQuantity: {
      value: Number(glucoseValue),
      unit: 'mmol/L',
      system: 'http://unitsofmeasure.org',
      code: 'mmol/L'
    }
  };
  var idMap = diabetesData.idMap;

  if (idMap && idMap.glucose) {
    observation.id = idMap.glucose;
  }

  return observation;
}

export { mapToFHIRGlucose };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapToFHIRGlucose, "mapToFHIRGlucose", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/mappers/mapToFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();